import BasicChart from "./basic-chart";

export default function MarketPlaceChart(props: any) {
  return (
    <BasicChart {...props} url="/operation/get-market-place" chartType="line" />
  );
}
